<div *transloco="let t" class="flex flex-col gap-4">
  <div>
    <pxc-select-label data-testid="input" [autocomplete]="false" [(selectedLabels)]="labelsToCreate" />
    <p class="mt-2 text-sm text-text-tertiary">{{ t("Appuyer sur entrée pour valider l'ajout du mot clé.") }}</p>
  </div>
  <div class="flex justify-between gap-2">
    <button appearance="outline" data-testid="cancel-button" tuiButton type="button" (click)="cancel()">
      {{ t('Annuler') }}
    </button>
    <button
      data-testid="add-button"
      tuiButton
      type="button"
      [disabled]="labelsToCreate.length === 0"
      (click)="confirm()">
      {{ t('Ajouter') }}
    </button>
  </div>
</div>
